import { ContactaProps } from './Contacta.types';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Tabs from 'components/corporatiu/Tabs';

const Contacta = (props: Readonly<ContactaProps>) => {
    const { items, tabs } = props;
    const preFormulari = items?.preFormulari;
    const resolvedTabs = tabs || items?.tabs;

    return (
        <>
            <Text text={preFormulari} />
            <Tabs tabs={resolvedTabs} id='contacta-tabs' estil='faqs' />
        </>
    );
};

export default Contacta;
